
@if (columnsNameDataTable.length > 0) {
  <div class="row filter-content w-100 p-3">
    @for (colum of columnsNameDataTable; track colum) {
      <div class="content pb-3 d-flex flex-column"
        [ngClass]="columnsNameDataTable.length > 6 ? 'col-2': 'col-3' "
        [style]="columnsNameDataTable.length > 6 ? '': 'width: '.concat( (100/columnsNameDataTable.length).toString(), '%' )"
        >
        <label class="efx-label"> {{ colum.columLabel }} </label>
        <input class="efx-input"
          type="text"
          (keyup)="applyFilterEmit($event, colum.columVar)"
          [placeholder]="colum.columLabel"
          [id]="colum.columVar"
          #inputRef />
        </div>
      }
    </div>
  }
